module.exports = __webpack_public_path__ + "static/amy.96cb79db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/amy.jpg
// module id = 447
// module chunks = 193747675109532